export const timestampToHumanTime = (timestamp: number, includeHours: boolean): string => {
  const timeInt = parseInt(timestamp.toString(), 10);

  const seconds = padWithZero(timeInt % 60);
  const minutes = padWithZero(Math.floor(timeInt / 60) % 60);
  const hours = includeHours ? `${padWithZero(Math.floor(timeInt / 3600) % 60)}:` : '';

  return `${hours}${minutes}:${seconds}`;
};

const padWithZero = (num: number): string => {
  if (num < 10) {
    return `0${num}`;
  }

  return num.toString();
};
